import { useEffect, useMemo, useState } from 'react'
import { FixedPriceType } from '../config/registrationConfig'
import useFixedPriceTypes from './useFixedPriceTypes'

export default function useFixedPriceType(id?: string): [FixedPriceType, (id: string) => void] {
    const [_id, setId] = useState<string>(id)
    const { loaded, fixedPriceTypes } = useFixedPriceTypes()

    const fixedPriceType = useMemo(
        () => loaded && (fixedPriceTypes || []).find(disbursementType => disbursementType.id === _id),
        [_id, loaded, fixedPriceTypes],
    )

    useEffect(() => {
        setId(id)
    }, [id])

    return [fixedPriceType, setId]
}
